import i from 'icepick'
import { get } from 'lodash'

const initialState = {}

export default (state = initialState, action) => {
  const count = action.meta && action.meta.id ? get(state, action.meta.id + '.count', 0) : 0

  switch (action.type) {
    case 'FILES/UPLOAD_PENDING':
      return i.assoc(state, action.meta.id, { count: count + 1, loading: true })
    case 'FILES/UPLOAD_FULFILLED':
      return i.assoc(state, action.meta.id, { count: count - 1, loading: count > 1 })
    case 'FILES/UPLOAD_REJECTED':
      return i.assoc(state, action.meta.id, { count: count - 1, loading: count > 1 })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/Files.reducer.js